import React, { useContext } from "react";
import {
    Box,
    Table as MuiTable,
    Collapse,
    IconButton,
    TableCell,
    TableHead,
    TableRow,
    TableBody
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {PriceListModel} from "../../../models/priceList";
import {DateUtils} from "../../../../helpers/dateUtils";
import i18n from "../../../../i18n/i18n";
import {TableActionFunction} from "../../../../common/components/shared/table/table";
import { Utils } from "../../../../helpers/utils";
import { storesContext } from "../../../../common/stores/stores";

interface PriceListRowProps {
    row: PriceListModel;
    properties: string[];
    subHeaders: string[];
    testId: string;
    actions: TableActionFunction;
}


export default function PriceListRow(props: PriceListRowProps) {
    const [open, setOpen] = React.useState(false);
    const userStore = useContext(storesContext).userStore;

    function renderHeaderDefault(header: string, index?: number, align?: "left" | "right") {
        return (
            <TableCell key={`header-${index}`} align={align || "left"}>
                {header}
            </TableCell>
        );
    }

    return (
        <React.Fragment>
            <TableRow sx={{ "& > *": { borderBottom: "unset" } }} data-testid={`${props.testId}`}>
                <TableCell>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                        data-testid={`${props.testId}-button`}
                    >
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell component="td" scope="row">
                    {i18n.t(`relationType.${props.row.priceListType}`)}
                </TableCell>
                <TableCell align="left">{DateUtils.getFormattedDate(props.row.startDate)}</TableCell>
                <TableCell align="right" className="actions">
                    {props.actions(props.row)}
                </TableCell>
            </TableRow>
            {open && (<TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: 0, paddingRight: 0 }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{ margin: 1 }}>
                            <MuiTable className="parking-rates-table" size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        {props.subHeaders.map((header, index) => {
                                            return renderHeaderDefault(header, index, "right");
                                        })}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {props.row.parkingRates.map((parkingRate) => {
                                        return (
                                            <TableRow key={parkingRate.parkingTime}>
                                                <TableCell component="td" scope="row" align="right">
                                                    {parkingRate.parkingTime}
                                                </TableCell>
                                                <TableCell align="right">{Utils.changePriceFormatByLanguage(parkingRate.parkingFee, userStore.language)}</TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </MuiTable>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>)}
        </React.Fragment>
    );
}